import { combineReducers } from "redux";
import reportDetailsReducer from "./reportDetailsReducer";
import resources from "./resourcesReducer";
import menu from "./menuReducer";
import user from "./userReducer";
import datasets from "./datasetsReducer";

import {persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const persistConfig={
    key:'root',
    storage,
    whitelist:[]
}

const rootReducer = combineReducers({
  //add reducers
  datasets,
  resources,
  report:reportDetailsReducer,
  menu,
  user
});

export default persistReducer(persistConfig,rootReducer);